import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf3fed94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Arborescence des catégories", -1))
const _hoisted_2 = {
  key: 0,
  class: "spinnerContainer"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "toggleTreeItemsBtnContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus-circle" }, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }

import { ref, onMounted, watch } from "vue";
import ApiService from "@/_services/api.service";
import swal from "../../../_helpers/swal";
import Tree from "primevue/tree";
import ProgressSpinner from "primevue/progressspinner";
import { useRouter } from "vue-router";

interface ICategory {
    key: string;
    label: string;
    data: string;
    type?: string;
    icon: string;
    expandedIcon?: string;
    collapsedIcon?: string;
    styleClass?: string;
    style?: string;
    children?: [] | ICategory[];
    leaf?: boolean;
}

const collapsedIcon = "pi-plus";
const expandedIcon = "pi-minus";
const enableCategoryClass = "activeCategory";
const disableCategoryClass = "inactiveCategory";
const hasCategoryChildrenClass = "hasChildren";
const hasNotCategoryChildrenClass = "hasNotChildren";
const categoriesApiUrl = "categories";

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesTreeView',
  setup(__props) {

const isLoading = ref<boolean>(true);
const categories = ref(Array<ICategory>());
const expandedKeys = ref({});
const router = useRouter();

watch(
    categories,
    () => {
        isLoading.value = categories.value.length < 1;
    },
    { deep: true }
);

onMounted(async () => {
    categories.value = await fetchCategoriesData();
});

async function fetchCategoriesData() {
    ApiService.get(categoriesApiUrl, {
        params: { lvl: 1, "order[lft]": "ASC" },
    })
        .then(({ data }) => {
            if (data.data.length > 0) {
                data.data.forEach((item, index: number) => {
                    let styleClasses = [
                        true === item.enabled ? enableCategoryClass : disableCategoryClass,
                        item.children?.length > 0
                            ? hasCategoryChildrenClass
                            : hasNotCategoryChildrenClass,
                    ].join(" ");
                    let id = index.toString();
                    let newCategory: ICategory = {
                        key: id,
                        label: item.name,
                        data: item.children?.length
                            ? router.resolve({
                                name: "listCategories",
                                params: { uuid: item.uuid },
                            }).href
                            : "",
                        type: "url",
                        icon: "",
                        expandedIcon: expandedIcon,
                        collapsedIcon: collapsedIcon,
                        styleClass: styleClasses,
                        children: formatChildrenToCategory(item.children, id),
                        leaf: item.children?.length > 0,
                    };
                    categories.value.push(newCategory);
                });
            }
        })
        .catch((error) => {
            console.dir(error);
            swal.error();
            return false;
        });

    return categories.value;
}

function formatChildrenToCategory(data, parentKey: string) {
    let childrenData = Array<ICategory>();
    data.forEach((item, index: number) => {
        let styleClasses = [
            true === item.enabled ? enableCategoryClass : disableCategoryClass,
            item.children?.length > 0
                ? hasCategoryChildrenClass
                : hasNotCategoryChildrenClass,
        ].join(" ");
        let key = parentKey + "-" + index;
        let newCategory: ICategory = {
            key: key,
            label: item.name,
            data: item.children?.length
                ? router.resolve({
                    name: "listCategories",
                    params: { uuid: item.uuid },
                }).href
                : "",
            type: "url",
            icon: "",
            expandedIcon: expandedIcon,
            collapsedIcon: collapsedIcon,
            styleClass: styleClasses,
            children:
                item.children && item.children.length
                    ? formatChildrenToCategory(item.children, key)
                    : [],
            leaf: item.children?.length > 0,
        };
        childrenData.push(newCategory);
    });

    return childrenData;
}

function expandAll() {
    for (let category of categories.value) {
        expandNode(category);
    }

    expandedKeys.value = { ...expandedKeys.value };
}

function collapseAll() {
    expandedKeys.value = {};
}

function expandNode(category: ICategory) {
    if (category.children && category.children.length) {
        expandedKeys.value[category.key] = true;

        for (let child of category.children) {
            expandNode(child);
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ProgressSpinner), {
            "aria-label": "Chargement",
            pt: {
            spinner: { style: { width: '50px', height: '50px', animationDuration: '.5s' } },
            circle: { style: { stroke: '#007bff', strokeWidth: 4, animation: '2s' } }
        }
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (expandAll()))
            }, [
              _hoisted_5,
              _createTextVNode(" Dérouler la liste ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (collapseAll()))
            }, [
              _hoisted_6,
              _createTextVNode(" Enrouler la liste ")
            ])
          ]),
          _createVNode(_unref(Tree), {
            value: categories.value,
            loading: isLoading.value,
            expandedKeys: expandedKeys.value,
            "onUpdate:expandedKeys": _cache[2] || (_cache[2] = ($event: any) => ((expandedKeys).value = $event))
          }, {
            default: _withCtx((slotProps) => [
              _createElementVNode("b", null, _toDisplayString(slotProps.node.label), 1)
            ]),
            url: _withCtx((slotProps) => [
              (slotProps.node.children?.length)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: slotProps.node.data
                  }, _toDisplayString(slotProps.node.label), 9, _hoisted_7))
                : (_openBlock(), _createElementBlock("a", _hoisted_8, _toDisplayString(slotProps.node.label), 1))
            ]),
            _: 1
          }, 8, ["value", "loading", "expandedKeys"])
        ]))
  ], 64))
}
}

})